export function hashScroll() {
    $(window).on("load", function () {
        if (window.location.hash) {
            let hash = window.location.hash;

            if ($(hash).length && !$(hash).hasClass('gform_anchor')) {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - $('.header').innerHeight()
                }, 900, 'swing');
                setTimeout(function () {
                    $("body").removeClass('up').addClass('down');
                }, 1000);
            } else {
                setTimeout(function () {
                    $("body").removeClass('up').addClass('down');
                }, 500);
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/hashScroll.js